import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _slicedToArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { Iterable } from '../../../common/iterator.js';
import { Event } from '../../../common/event.js';
import { TreeError, WeakMapper } from './tree.js';
import { ObjectTreeModel } from './objectTreeModel.js';

function noCompress(element) {
  var elements = [element.element];
  var incompressible = element.incompressible || false;
  return {
    element: {
      elements: elements,
      incompressible: incompressible
    },
    children: Iterable.map(Iterable.from(element.children), noCompress),
    collapsible: element.collapsible,
    collapsed: element.collapsed
  };
} // Exported only for test reasons, do not use directly


export function compress(element) {
  var elements = [element.element];
  var incompressible = element.incompressible || false;
  var childrenIterator;
  var children;

  while (true) {
    var _Iterable$consume = Iterable.consume(Iterable.from(element.children), 2);

    var _Iterable$consume2 = _slicedToArray(_Iterable$consume, 2);

    children = _Iterable$consume2[0];
    childrenIterator = _Iterable$consume2[1];

    if (children.length !== 1) {
      break;
    }

    element = children[0];

    if (element.incompressible) {
      break;
    }

    elements.push(element.element);
  }

  return {
    element: {
      elements: elements,
      incompressible: incompressible
    },
    children: Iterable.map(Iterable.concat(children, childrenIterator), compress),
    collapsible: element.collapsible,
    collapsed: element.collapsed
  };
}

function _decompress(element) {
  var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var children;

  if (index < element.element.elements.length - 1) {
    children = [_decompress(element, index + 1)];
  } else {
    children = Iterable.map(Iterable.from(element.children), function (el) {
      return _decompress(el, 0);
    });
  }

  if (index === 0 && element.element.incompressible) {
    return {
      element: element.element.elements[index],
      children: children,
      incompressible: true,
      collapsible: element.collapsible,
      collapsed: element.collapsed
    };
  }

  return {
    element: element.element.elements[index],
    children: children,
    collapsible: element.collapsible,
    collapsed: element.collapsed
  };
} // Exported only for test reasons, do not use directly


export function decompress(element) {
  return _decompress(element, 0);
}

function splice(treeElement, element, children) {
  if (treeElement.element === element) {
    return Object.assign(Object.assign({}, treeElement), {
      children: children
    });
  }

  return Object.assign(Object.assign({}, treeElement), {
    children: Iterable.map(Iterable.from(treeElement.children), function (e) {
      return splice(e, element, children);
    })
  });
} // Exported only for test reasons, do not use directly


export var CompressedObjectTreeModel = /*#__PURE__*/function () {
  function CompressedObjectTreeModel(user, list) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, CompressedObjectTreeModel);

    this.user = user;
    this.rootRef = null;
    this.nodes = new Map();
    this.model = new ObjectTreeModel(user, list, options);
    this.enabled = typeof options.compressionEnabled === 'undefined' ? true : options.compressionEnabled;
  }

  _createClass(CompressedObjectTreeModel, [{
    key: "onDidSplice",
    get: function get() {
      return this.model.onDidSplice;
    }
  }, {
    key: "onDidChangeCollapseState",
    get: function get() {
      return this.model.onDidChangeCollapseState;
    }
  }, {
    key: "onDidChangeRenderNodeCount",
    get: function get() {
      return this.model.onDidChangeRenderNodeCount;
    }
  }, {
    key: "setChildren",
    value: function setChildren(element) {
      var children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Iterable.empty();

      if (element === null) {
        var compressedChildren = Iterable.map(children, this.enabled ? compress : noCompress);

        this._setChildren(null, compressedChildren);

        return;
      }

      var compressedNode = this.nodes.get(element);

      if (!compressedNode) {
        throw new Error('Unknown compressed tree node');
      }

      var node = this.model.getNode(compressedNode);
      var compressedParentNode = this.model.getParentNodeLocation(compressedNode);
      var parent = this.model.getNode(compressedParentNode);
      var decompressedElement = decompress(node);
      var splicedElement = splice(decompressedElement, element, children);
      var recompressedElement = (this.enabled ? compress : noCompress)(splicedElement);
      var parentChildren = parent.children.map(function (child) {
        return child === node ? recompressedElement : child;
      });

      this._setChildren(parent.element, parentChildren);
    }
  }, {
    key: "setCompressionEnabled",
    value: function setCompressionEnabled(enabled) {
      if (enabled === this.enabled) {
        return;
      }

      this.enabled = enabled;
      var root = this.model.getNode();
      var rootChildren = root.children;
      var decompressedRootChildren = Iterable.map(rootChildren, decompress);
      var recompressedRootChildren = Iterable.map(decompressedRootChildren, enabled ? compress : noCompress);

      this._setChildren(null, recompressedRootChildren);
    }
  }, {
    key: "_setChildren",
    value: function _setChildren(node, children) {
      var _this = this;

      var insertedElements = new Set();

      var _onDidCreateNode = function _onDidCreateNode(node) {
        var _iterator = _createForOfIteratorHelper(node.element.elements),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var element = _step.value;
            insertedElements.add(element);

            _this.nodes.set(element, node.element);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      };

      var _onDidDeleteNode = function _onDidDeleteNode(node) {
        var _iterator2 = _createForOfIteratorHelper(node.element.elements),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var element = _step2.value;

            if (!insertedElements.has(element)) {
              _this.nodes.delete(element);
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      };

      this.model.setChildren(node, children, _onDidCreateNode, _onDidDeleteNode);
    }
  }, {
    key: "has",
    value: function has(element) {
      return this.nodes.has(element);
    }
  }, {
    key: "getListIndex",
    value: function getListIndex(location) {
      var node = this.getCompressedNode(location);
      return this.model.getListIndex(node);
    }
  }, {
    key: "getListRenderCount",
    value: function getListRenderCount(location) {
      var node = this.getCompressedNode(location);
      return this.model.getListRenderCount(node);
    }
  }, {
    key: "getNode",
    value: function getNode(location) {
      if (typeof location === 'undefined') {
        return this.model.getNode();
      }

      var node = this.getCompressedNode(location);
      return this.model.getNode(node);
    } // TODO: review this

  }, {
    key: "getNodeLocation",
    value: function getNodeLocation(node) {
      var compressedNode = this.model.getNodeLocation(node);

      if (compressedNode === null) {
        return null;
      }

      return compressedNode.elements[compressedNode.elements.length - 1];
    } // TODO: review this

  }, {
    key: "getParentNodeLocation",
    value: function getParentNodeLocation(location) {
      var compressedNode = this.getCompressedNode(location);
      var parentNode = this.model.getParentNodeLocation(compressedNode);

      if (parentNode === null) {
        return null;
      }

      return parentNode.elements[parentNode.elements.length - 1];
    }
  }, {
    key: "isCollapsible",
    value: function isCollapsible(location) {
      var compressedNode = this.getCompressedNode(location);
      return this.model.isCollapsible(compressedNode);
    }
  }, {
    key: "setCollapsible",
    value: function setCollapsible(location, collapsible) {
      var compressedNode = this.getCompressedNode(location);
      return this.model.setCollapsible(compressedNode, collapsible);
    }
  }, {
    key: "isCollapsed",
    value: function isCollapsed(location) {
      var compressedNode = this.getCompressedNode(location);
      return this.model.isCollapsed(compressedNode);
    }
  }, {
    key: "setCollapsed",
    value: function setCollapsed(location, collapsed, recursive) {
      var compressedNode = this.getCompressedNode(location);
      return this.model.setCollapsed(compressedNode, collapsed, recursive);
    }
  }, {
    key: "expandTo",
    value: function expandTo(location) {
      var compressedNode = this.getCompressedNode(location);
      this.model.expandTo(compressedNode);
    }
  }, {
    key: "rerender",
    value: function rerender(location) {
      var compressedNode = this.getCompressedNode(location);
      this.model.rerender(compressedNode);
    }
  }, {
    key: "refilter",
    value: function refilter() {
      this.model.refilter();
    }
  }, {
    key: "getCompressedNode",
    value: function getCompressedNode(element) {
      if (element === null) {
        return null;
      }

      var node = this.nodes.get(element);

      if (!node) {
        throw new TreeError(this.user, "Tree element not found: ".concat(element));
      }

      return node;
    }
  }]);

  return CompressedObjectTreeModel;
}();
export var DefaultElementMapper = function DefaultElementMapper(elements) {
  return elements[elements.length - 1];
};

var CompressedTreeNodeWrapper = /*#__PURE__*/function () {
  function CompressedTreeNodeWrapper(unwrapper, node) {
    _classCallCheck(this, CompressedTreeNodeWrapper);

    this.unwrapper = unwrapper;
    this.node = node;
  }

  _createClass(CompressedTreeNodeWrapper, [{
    key: "element",
    get: function get() {
      return this.node.element === null ? null : this.unwrapper(this.node.element);
    }
  }, {
    key: "children",
    get: function get() {
      var _this2 = this;

      return this.node.children.map(function (node) {
        return new CompressedTreeNodeWrapper(_this2.unwrapper, node);
      });
    }
  }, {
    key: "depth",
    get: function get() {
      return this.node.depth;
    }
  }, {
    key: "visibleChildrenCount",
    get: function get() {
      return this.node.visibleChildrenCount;
    }
  }, {
    key: "visibleChildIndex",
    get: function get() {
      return this.node.visibleChildIndex;
    }
  }, {
    key: "collapsible",
    get: function get() {
      return this.node.collapsible;
    }
  }, {
    key: "collapsed",
    get: function get() {
      return this.node.collapsed;
    }
  }, {
    key: "visible",
    get: function get() {
      return this.node.visible;
    }
  }, {
    key: "filterData",
    get: function get() {
      return this.node.filterData;
    }
  }]);

  return CompressedTreeNodeWrapper;
}();

function mapList(nodeMapper, list) {
  return {
    splice: function splice(start, deleteCount, toInsert) {
      list.splice(start, deleteCount, toInsert.map(function (node) {
        return nodeMapper.map(node);
      }));
    },
    updateElementHeight: function updateElementHeight(index, height) {
      list.updateElementHeight(index, height);
    }
  };
}

function mapOptions(compressedNodeUnwrapper, options) {
  return Object.assign(Object.assign({}, options), {
    sorter: options.sorter && {
      compare: function compare(node, otherNode) {
        return options.sorter.compare(node.elements[0], otherNode.elements[0]);
      }
    },
    identityProvider: options.identityProvider && {
      getId: function getId(node) {
        return options.identityProvider.getId(compressedNodeUnwrapper(node));
      }
    },
    filter: options.filter && {
      filter: function filter(node, parentVisibility) {
        return options.filter.filter(compressedNodeUnwrapper(node), parentVisibility);
      }
    }
  });
}

export var CompressibleObjectTreeModel = /*#__PURE__*/function () {
  function CompressibleObjectTreeModel(user, list) {
    var _this3 = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, CompressibleObjectTreeModel);

    this.rootRef = null;
    this.elementMapper = options.elementMapper || DefaultElementMapper;

    var compressedNodeUnwrapper = function compressedNodeUnwrapper(node) {
      return _this3.elementMapper(node.elements);
    };

    this.nodeMapper = new WeakMapper(function (node) {
      return new CompressedTreeNodeWrapper(compressedNodeUnwrapper, node);
    });
    this.model = new CompressedObjectTreeModel(user, mapList(this.nodeMapper, list), mapOptions(compressedNodeUnwrapper, options));
  }

  _createClass(CompressibleObjectTreeModel, [{
    key: "onDidSplice",
    get: function get() {
      var _this4 = this;

      return Event.map(this.model.onDidSplice, function (_ref) {
        var insertedNodes = _ref.insertedNodes,
            deletedNodes = _ref.deletedNodes;
        return {
          insertedNodes: insertedNodes.map(function (node) {
            return _this4.nodeMapper.map(node);
          }),
          deletedNodes: deletedNodes.map(function (node) {
            return _this4.nodeMapper.map(node);
          })
        };
      });
    }
  }, {
    key: "onDidChangeCollapseState",
    get: function get() {
      var _this5 = this;

      return Event.map(this.model.onDidChangeCollapseState, function (_ref2) {
        var node = _ref2.node,
            deep = _ref2.deep;
        return {
          node: _this5.nodeMapper.map(node),
          deep: deep
        };
      });
    }
  }, {
    key: "onDidChangeRenderNodeCount",
    get: function get() {
      var _this6 = this;

      return Event.map(this.model.onDidChangeRenderNodeCount, function (node) {
        return _this6.nodeMapper.map(node);
      });
    }
  }, {
    key: "setChildren",
    value: function setChildren(element) {
      var children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Iterable.empty();
      this.model.setChildren(element, children);
    }
  }, {
    key: "setCompressionEnabled",
    value: function setCompressionEnabled(enabled) {
      this.model.setCompressionEnabled(enabled);
    }
  }, {
    key: "has",
    value: function has(location) {
      return this.model.has(location);
    }
  }, {
    key: "getListIndex",
    value: function getListIndex(location) {
      return this.model.getListIndex(location);
    }
  }, {
    key: "getListRenderCount",
    value: function getListRenderCount(location) {
      return this.model.getListRenderCount(location);
    }
  }, {
    key: "getNode",
    value: function getNode(location) {
      return this.nodeMapper.map(this.model.getNode(location));
    }
  }, {
    key: "getNodeLocation",
    value: function getNodeLocation(node) {
      return node.element;
    }
  }, {
    key: "getParentNodeLocation",
    value: function getParentNodeLocation(location) {
      return this.model.getParentNodeLocation(location);
    }
  }, {
    key: "isCollapsible",
    value: function isCollapsible(location) {
      return this.model.isCollapsible(location);
    }
  }, {
    key: "setCollapsible",
    value: function setCollapsible(location, collapsed) {
      return this.model.setCollapsible(location, collapsed);
    }
  }, {
    key: "isCollapsed",
    value: function isCollapsed(location) {
      return this.model.isCollapsed(location);
    }
  }, {
    key: "setCollapsed",
    value: function setCollapsed(location, collapsed, recursive) {
      return this.model.setCollapsed(location, collapsed, recursive);
    }
  }, {
    key: "expandTo",
    value: function expandTo(location) {
      return this.model.expandTo(location);
    }
  }, {
    key: "rerender",
    value: function rerender(location) {
      return this.model.rerender(location);
    }
  }, {
    key: "refilter",
    value: function refilter() {
      return this.model.refilter();
    }
  }, {
    key: "getCompressedTreeNode",
    value: function getCompressedTreeNode() {
      var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return this.model.getNode(location);
    }
  }]);

  return CompressibleObjectTreeModel;
}();